import React, { useEffect } from 'react'
import '../../../assets/styles/pages/homeCss/requestDemo.css'
import { Col, Container, Row } from 'react-bootstrap'
import laptop from '../../../assets/images/homeImages/Apple-Macbook-Gold.png'
import AOS from 'aos'

const RequestDemo = () => {
  useEffect(() => {
    AOS.init({ duration: 2000, },);
  }, [])


  return (
    <section className='requestDemo-main'>
      <Container >
        <Row className=' container'>
          <Col md={4} lg={4}>
            <div className='requestDemo-main-form l'>
              <h1 className=' Request-h1' data-aos='fade-left'>Request your Demo</h1>
              <p className='Request_p' data-aos='fade-left'>Let’s learn more about your business needs and provide you with a tailored demo around to help you meet your goals.</p>
              <div className="all-request-input">
                <div data-aos='fade-left'>
                  <input className='Request-inputs mt-4' rea="true" placeholder='' defaultValue="Johnatan Snowden" type="text" />
                </div>
                <div data-aos='fade-left'>
                  <input className='Request-inputs mt-4' placeholder='Work email' type="text" />
                </div>
                <div data-aos='fade-left'>
                  <input className='Request-inputs mt-4' placeholder='Phone number' type="text" />
                </div>
                <div data-aos='fade-left'>
                  <button className='Request-btn mt-4'>Submit</button>
                </div>
              </div>
            </div>

          </Col>
          <Col md={6} lg={6}>
            <div className='requestDemo-img text-center'>
              <img data-aos='fade-right' src={laptop} alt="fade" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default RequestDemo
